import { ENVS, getEnv } from '@adsk/acs-sc-web-platform-api';

declare const __webpack_public_path__: string;

function getDynatraceScriptName() {
  const env = getEnv();

  if (env === ENVS.QA) {
    return 'qaAgent';
  }

  if (env === ENVS.STAGING) {
    return 'stagingAgent';
  }

  const urlParams = new URLSearchParams(window.location.search);
  if (
    env === ENVS.PRODUCTION &&
    urlParams.get('dynatraceInitialize') === 'true'
  ) {
    return 'productionAgent';
  }
  return undefined;
}

const scriptName = getDynatraceScriptName();
if (scriptName) {
  const scriptElement = document.createElement('script');
  scriptElement.id = 'dynatrace-agent';
  scriptElement.src = `${__webpack_public_path__}${scriptName}.js`;
  document.head.appendChild(scriptElement);
}
